import type { IButtonPropsBase } from './button.type';

export const getLoaderSize = (size: IButtonPropsBase['size']): string => {
  switch (size) {
    case 'large':
      return '1.5rem';

    case 'medium':
    case 'small':
    default:
      return '1rem';
  }
};
